import React, { useContext } from 'react'
import { StatusContext } from '../contexts/Status.context'


const useTranslation = () => {
  const {lang, translations} = useContext(StatusContext)

  const t = (key: string) => {
    return (translations as any)[lang]? ((translations as any)[lang][key] ? (translations as any)[lang][key] : key) : key
  }

  return {t}
}

export default useTranslation